import { useQuery } from '@tanstack/react-query';
import { getEthnicities } from '@uplift/api';
import { BaseQueryOpts } from './baseTypes';

export const useEthnicitiesQuery = (opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'ethnicities' ],
    queryFn: getEthnicities,
    select: (data) => data.data,
    ...opts,
  });
};
